import React from "react";
import { CloseIcon } from "../../assets/icons";
import cx from "classnames";
import { VendorT } from "../../types";
import CreateVendorForm from "./Createvendor";
import { createVendor } from "../../backend-services/vendor";
import { IVendor } from "../../@types";
import { showToast } from "../../utils/toastUtils";

interface CreateVendorProps {
  onVendorCreate?: (vendor: any) => void;
  show: boolean;
  onClose?: () => void;
  handleSelectedVendor?: (selectedVendor: IVendor | null) => void;
}

const AddVendors = ({
  onVendorCreate,
  show,
  onClose,
  handleSelectedVendor,
}: CreateVendorProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
    const [formData, setFormData] = React.useState<IVendor>({
      id: "",
      name: "",
      lastName: "",
      createdAt: Date.now(),
      phone: "",
      address: "",
      city: "",
      state: "",
    });

  const handleCreateVendor = async (vendor: VendorT) => {
    setIsLoading(true);
    setErrorMessage("");

    if (!vendor.name) {
      setErrorMessage("The name field is required.");
      setIsLoading(false);
      return;
    }

    const flatVendor = {
      name: vendor.name,
      phone: vendor.phone,
      address: vendor.address,
      city: vendor.city,
      state: vendor.state,
    };

    try {
      const data = await createVendor(flatVendor);
      setIsLoading(false);
      setIsOpen(false);
      showToast("Vendor created successfully!", "success")
      if (onVendorCreate) {
        onVendorCreate({
          id: data.id,
          name: data.name,
          phone: data.phone,
          address: data.address,
        });
      }
      if (onClose) onClose();
    } catch (error: any) {
      setErrorMessage(error.message || "Error creating vendor");
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  React.useEffect(() => {
    setIsOpen(show);
  }, [show]);

  return isOpen ? (
    <>
      {/* Modal Background */}
      <div
        aria-hidden="false"
        className="lg:hidden md:hidden w-full fixed top-0 right-0 left-0 z-50 h-full overflow-y-auto overflow-x-hidden items-start flex bg-gray-900 bg-opacity-50"
      >
        <div
          className={cx({
            "relative z-50 overflow-y-auto": true,
            "p-3 w-full md:max-w-lg bg-white shadow h-[100vh]": true,
            "": isOpen,
          })}
        >
          <div className="flex justify-between items-center pt-[20px] mb-[20px]">
            <h3 className="text-[25px] font-semibold pl-[20px]">
              {"Add New Vendor"}
            </h3>
            <button
              aria-label="Close"
              className="md:mr-[2em] inline-flex items-center rounded-lg  py-2 pr-3  text-[black]"
              type="button"
              onClick={handleClose}
            >
              <CloseIcon />
            </button>
          </div>

          {/* MODAL BODY */}
          <div className="p-4">
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <CreateVendorForm
              isLoading={isLoading}
              show={true}
              onSubmit={handleCreateVendor}
              buttontitle={"Add Vendor"}
              onSelectVendor={handleSelectedVendor}
            />
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export { AddVendors };
